import React, { useEffect, useState } from 'react';
import { DndProvider, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import CheckAlcoholModal from '../../../components/modal/CheckAlcoholModal';
import ConfirmModal from '../../../components/modal/ConfirmModal';
import ProductController, {
  CategoryType,
  ProductType,
} from '../../../controller/ProductController';
import { CurrentStoreContext } from '../../../controller/StoreController';
import { useToast } from '../../../controller/ToastController';

const CategoryEdit = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const location = useLocation();
  const categoryInfo: CategoryType = location.state?.categoryInfo;

  const [name, setName] = useState<string>('');
  const [productList, setProductList] = useState<ProductType[]>([]);

  const [keyword, setKeyword] = useState<string>('');
  const [allProductList, setAllProductList] = useState<ProductType[]>([]);
  const [searchedList, setSearchedList] = useState<ProductType[]>([]);

  const [visibleAlcohol, setVisibleAlcohol] = useState<boolean>(false);
  const [checkAdult, setCheckAdult] = useState<number>(0);

  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);
  const [visibleNavigate, setVisibleNavigate] = useState<boolean>(false);

  const [addedList, setAddedList] = useState<any>([]);

  const deleteCategory = () => {
    deleteCategoryData();
    setVisibleConfirm(false);
  };

  const navigateProductEdit = () => {
    navigate(`/product/product/edit`);
    setVisibleNavigate(false);
  };

  const onChange_name = (event: any) => {
    setName(event.target.value);
  };
  const onChange_adult = () => {
    if (checkAdult === 0) {
      setVisibleAlcohol(true);
    }
  };

  // 필수 확인
  const checkRequired = () => {
    if (name.length > 0) return true;
    return false;
  };

  // 상품 추가
  const addProductList = (prd_id: number, is_set: number) => {
    if (!productList.some((item) => item.prd_id === prd_id && item.is_set === is_set)) {
      const selectedProduct = allProductList.filter(
        (item) => item.prd_id === prd_id && item.is_set === is_set,
      );
      setProductList([...productList, ...selectedProduct]);
      showToast('상품을 등록했어요');
    } else {
      showToast('이미 등록된 상품이에요', 'error');
    }
  };
  const deleteProductList = (index: number) => {
    productList.splice(index, 1);
    setProductList([...productList]);
  };

  // 검색
  const getSearchResult = () => {
    setSearchedList(allProductList.filter((item) => item.prd_name.includes(keyword)));
  };

  // API 호출
  const setCategoryData = async () => {
    try {
      if (checkRequired()) {
        const productTemp: any = [];
        productList.map((item: ProductType) => {
          productTemp.push({ product_id: item.prd_id, is_set: item.is_set });
        });
        console.log(productTemp);

        if (categoryInfo) {
          const category = {
            name: name,
            category_id: categoryInfo.category_id,
            is_main: 1,
            is_for_adult: checkAdult,
            product_list: productTemp,
          };
          const oRes = await ProductController.editCateProduct(currentStore.value, category);
          if (oRes && oRes.data) {
            const oResponse = oRes.data;
            console.log('editCateProduct', oResponse);
            if (oResponse.data && oResponse.ok) {
              // console.log(productTemp);
              showToast('새로운 상품분류 정보를 등록했어요');
            }
          }
        } else {
          const category = {
            name: name,
            is_for_adult: checkAdult,
            product_list: productTemp,
          };
          const oRes = await ProductController.setCateProduct(currentStore.value, category);
          if (oRes && oRes.data) {
            const oResponse = oRes.data;
            console.log('setCateProduct', oResponse);
            if (oResponse.data && oResponse.ok) {
              // console.log(productTemp);
              showToast('새로운 상품분류 정보를 등록했어요');
              let addedTemp = addedList;
              addedTemp.push(category);
              setAddedList([...addedTemp]);
            }
          }
        }
      } else {
        showToast('필수 정보를 입력해주세요', 'error');
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const deleteCategoryData = async () => {
    try {
      const oRes = await ProductController.delCategory(categoryInfo.category_id);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('delCategory', oResponse);
        if (oResponse.data && oResponse.ok) {
          showToast('상품분류를 삭제했어요');
          navigate(-1);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const getAllProductList = async () => {
    try {
      const oRes = await ProductController.getAllProductList(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getAllProductList', oResponse);
        if (oResponse.data) {
          setAllProductList([...oResponse.data]);
          setSearchedList([...oResponse.data]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    console.log(categoryInfo);
    if (categoryInfo) {
      setName(categoryInfo.category_name);
      setCheckAdult(categoryInfo.is_for_adult);
      setProductList([...categoryInfo.product_list]);
    }
    getAllProductList();
  }, []);

  const moveItem = (fromIndex: number, toIndex: number) => {
    if (toIndex < 1) toIndex = 0;
    else if (toIndex > productList.length - 1) toIndex = productList.length;
    const newItems = [...productList];
    const [movedItem] = newItems.splice(fromIndex, 1);
    newItems.splice(toIndex, 0, movedItem);
    setProductList(newItems);
  };

  interface DraggableItemProps {
    item: ProductType;
    index: number;
    moveItem: (fromIndex: number, toIndex: number) => void;
  }

  const RenderPreviewItem = ({ item, index, moveItem }: DraggableItemProps) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(index + 1);
    const [, drag] = useDrag({
      type: 'ITEM',
      item: { item, index },
    });
    const [, drop] = useDrop({
      accept: 'ITEM',
      hover: (item: { index: number }, monitor: DropTargetMonitor) => {
        if (item.index !== index) {
          moveItem(item.index, index);
          item.index = index;
        }
      },
    });

    return (
      <div className="menuItem" key={index}>
        <div className="row">
          <input
            ref={(node) => drag(drop(node))}
            value={selectedIndex}
            autoFocus={false}
            onChange={(e) => {
              setSelectedIndex(Number(e.target.value));
            }}
            onBlur={() => {
              moveItem(index, selectedIndex - 1);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                moveItem(index, selectedIndex - 1);
              }
            }}
          />
          <div className="column">
            <h4>{item.prd_name}</h4>
            <h5>{`${item.prd_base_price.toLocaleString()}원`}</h5>
          </div>
        </div>
        <div className="row">
          {item.url_path !== '' && item.url_path !== null && (
            <div className="imgWrap">
              <img src={item.url_path} alt="ic" />
            </div>
          )}
          <img
            src={`${process.env.PUBLIC_URL}/svg/ic_trashcan.svg`}
            alt="ic"
            onClick={() => deleteProductList(index)}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="editHeaderWrap">
            <button className="backButton" onClick={() => navigate(-1)}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left.svg`} alt="ic" />
            </button>
            {categoryInfo && (
              <button className="deleteButton" onClick={() => setVisibleConfirm(true)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_trashcan_green.svg`} alt="ic" />
                <h5>상품분류 삭제</h5>
              </button>
            )}
          </div>
          <div className="inputText">
            <div className="title ">
              <h4>상품분류명</h4>
              <h5>(필수)</h5>
            </div>
            <input
              type="text"
              placeholder="상품분류명을 적어주세요"
              value={name}
              onChange={onChange_name}
              autoFocus={true}
            />
          </div>
          <label htmlFor="isAdult">
            <input
              id="isAdult"
              type="checkbox"
              checked={checkAdult === 1}
              onChange={onChange_adult}
              autoFocus={false}
            />
            주류 상품이 포함된 부류입니다.
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_adult.svg`}
              width={16}
              height={16}
              alt="ic"
            />
          </label>
          <div className="inputText">
            <div className="title">
              <h4>상품추가</h4>
            </div>
            <div className="search">
              <input
                type="text"
                value={keyword}
                placeholder="등록한 상품 중 추가할 상품명을 검색해주세요"
                autoFocus={false}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    getSearchResult();
                  }
                }}
              />
              <button className="searchBox" onClick={getSearchResult}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_search_grey.svg`} alt="search" />
              </button>
              <div className="searchedList">
                {searchedList.map((item: ProductType, index: number) => {
                  return (
                    <div key={index} className="searchedItem">
                      <h4>{item.prd_name}</h4>
                      <button
                        className="searchedAddButton"
                        onClick={() => addProductList(item.prd_id, item.is_set)}>
                        추가
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
            <button className="addButton" onClick={() => setVisibleNavigate(true)}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
              <h5>새 상품 만들기</h5>
            </button>
            <div className="warningSign">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
              <p>
                등록된 상품이 아닌 새로운 상품을 만들고 싶으면 ‘새 상품 만들기’ 버튼을 클릭해주세요
              </p>
            </div>
          </div>
        </div>

        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial">
              <h4>상품분류 미리보기</h4>
            </div>
            <div className="listItem">
              <div className="row gap">
                <div className="indexBox">1</div>
                <div className="row">
                  <h3>{name}</h3>
                  {checkAdult === 1 && (
                    <img src={`${process.env.PUBLIC_URL}/svg/ic_adult.svg`} alt="ic" />
                  )}
                </div>
              </div>
              <div className="row gap">
                <img src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`} alt="ic" />
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_arrow_down_grey.svg`}
                  width={30}
                  height={30}
                  alt="ic"
                />
              </div>
            </div>
            {productList.length > 0 && (
              <DndProvider backend={HTML5Backend}>
                <div className="menuList">
                  {productList.map((item: ProductType, index: number) => {
                    return (
                      <RenderPreviewItem
                        key={index}
                        item={item}
                        index={index}
                        moveItem={moveItem}
                      />
                    );
                  })}
                </div>
              </DndProvider>
            )}
            <div className="warningSign">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
              <p>숫자를 입력하거나 숫자 버튼을 드래그 해서 순서를 변경해주세요.</p>
            </div>
          </div>
          <button
            className={`submitButton ${!checkRequired() && 'inactive'}`}
            onClick={setCategoryData}>
            저장
          </button>
        </div>
      </Style>
      <CheckAlcoholModal
        isVisible={visibleAlcohol}
        setVisible={setVisibleAlcohol}
        setCheckAdult={setCheckAdult}
      />
      <ConfirmModal
        isOpen={visibleConfirm}
        title={`삭제 후 복구할 수 없습니다.\n정말 삭제하시겠어요?`}
        onCancelText="취소"
        onConfirmText="삭제"
        onCancel={() => setVisibleConfirm(false)}
        onConfirm={deleteCategory}
      />
      <ConfirmModal
        isOpen={visibleNavigate}
        title={`상품 등록 페이지로 이동하면\n변경사항이 저장되지 않아요.\n저장하지 않고 이동할까요?`}
        onCancelText="취소"
        onConfirmText="이동"
        onCancel={() => setVisibleNavigate(false)}
        onConfirm={navigateProductEdit}
      />
    </>
  );
};

export default CategoryEdit;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }

  .editHeaderWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .deleteButton {
      display: flex;
      align-items: center;
      padding: 6px 10px;
      border: 1px solid #40977f;
      border-radius: 5px;
      gap: 10px;
      h5 {
        color: #40977f;
      }
    }
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-top: 24px;
    h5 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  .search {
    width: 100%;
    position: relative;

    input {
      border-radius: 5px 5px 0 0;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-weight: 400;
      padding: 10px 20px;
    }
    input::placeholder {
      color: #cecece;
    }
    .searchBox {
      top: 0;
      padding: 8px 0;
      position: absolute;
      display: flex;
      align-items: center;
      cursor: pointer;
      right: 14px;
    }
    .searchedList {
      height: 200px;
      border-radius: 0 0 5px 5px;
      border: 1px solid #cecece;
      border-top: none;
      overflow-y: auto;
      .searchedItem {
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 20px;
        border-bottom: 1px solid #f7f7f7;
        h4 {
          color: #555555;
        }
        .searchedAddButton {
          border: 1px solid #4dd2ae;
          border-radius: 5px;
          color: #4dd2ae;
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
          padding: 5px 11px;
        }
      }
    }
  }

  .inputText {
    .row.gap {
      gap: 10px;
      align-items: flex-end;
    }

    img {
      cursor: pointer;
    }

    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 6px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .imageSpan {
        color: #979797;
        font-weight: 400;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }

    .inputWrap {
      position: relative;
      .unit {
        position: absolute;
        font-size: 16px;
        line-height: 22px;
        color: #a7a7a7;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
      }
    }
  }

  input,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #cecece;
    border-radius: 5px;
    color: #555555;
  }

  label {
    padding-top: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    line-height: 22px;
    font-weight: 400;
    color: #979797;
  }
  input[type='checkbox'] {
    accent-color: #40977f;
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }

  input::placeholder,
  textarea::placeholder {
    color: #cecece;
  }

  .listItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px 10px 22px;
    background: #ecf5f3;
    border: 1px solid #ecf5f3;
    border-radius: 5px 5px 0 0;

    .indexBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      padding: 4px;
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      text-align: center;
      color: #40977f;
      background: #ecf5f3;
      border: 1px solid #4dd2ae;
      border-radius: 4px;
    }
    .row {
      gap: 6px;
    }
    .row.gap {
      gap: 14px;
      align-items: center;
    }
  }

  .menuList {
    display: flex;
    flex-direction: column;
    border: 1px solid #e5e5e5;
    border-top: none;
    border-radius: 0 0 5px 5px;
    .menuItem {
      min-height: 65px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2px 20px;
      border-bottom: 1px solid #f7f7f7;
      input {
        width: 24px;
        height: 24px;
        padding: 4px;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #979797;
        background: #ffffff;
        border: 1px solid #cecece;
        border-radius: 4px;
      }

      .column {
        gap: 2px;
      }
      h4 {
        color: #555555;
        font-weight: 600;
      }
      h5 {
        color: #555555;
        font-weight: 400;
      }
      .row {
        gap: 20px;
        .imgWrap {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 60px;
          border-radius: 5px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 5px;
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    .searchedList {
      .searchedItem {
        padding: 8px 10px;
        h4 {
          font-size: 16px;
          color: #555555;
        }
      }
    }

    .listItem {
      padding: 8px 8px 8px 14px;
      .indexBox {
        width: 26px;
        height: 26px;
        font-size: 14px;
        line-height: 20px;
      }
      h3 {
        font-size: 18px;
      }
      .row.gap {
        gap: 10px;
      }
    }

    .menuList {
      .menuItem {
        min-height: 60px;
        padding: 2px 12px;
        h4 {
          font-size: 16px;
        }
        h5 {
          font-size: 12px;
        }
        .row {
          gap: 12px;
          .imgWrap {
            width: 50px;
            height: 50px;
          }
        }
      }
    }
  }
`;
